import react from '../images/react.png'
import css from '../images/css.png'
import js from '../images/js.png'
import html from '../images/html.png'
import node from '../images/node.png'
import mongo from '../images/mongodb.png'
import gatsby from '../images/gatsby.png'
import tail from '../images/tailwindcss.png'
import scss from '../images/sass.png'
import fire from '../images/firebase.png'
import sanity from '../images/sanity.png'
import post from '../images/postman.jpg'
import express from '../images/express.png'
import mail from '../images/mail.jpg'
import algolia from '../images/algolia.png'


/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    react,
    css,
    js,
    html,
    node,
    mongo,
    gatsby,
    tail,
    scss,
    fire,
    sanity,
    post,
    express,
    mail,
    algolia
}